import { setProgress, setMessages } from './ui.actions.js';

export const GET_CALENDAR_RESOURCES_BY_ORGS = 'GET_CALENDAR_RESOURCES_BY_ORGS';
export const GET_CALENDAR_RESOURCES_BY_ORGS_REQUEST = 'GET_CALENDAR_RESOURCES_BY_ORGS_REQUEST';
export const GET_CALENDAR_RESOURCES_BY_ORGS_FAILED = 'GET_CALENDAR_RESOURCES_BY_ORGS_FAILED';

export const GET_COUNTER_DATA = 'GET_COUNTER_DATA';
export const GET_COUNTER_DATA_REQUEST = 'GET_COUNTER_DATA_REQUEST';
export const GET_COUNTER_DATA_FAILED = 'GET_COUNTER_DATA_FAILED';

export const GET_RESOURCE_DATA = 'GET_RESOURCE_DATA';
export const GET_RESOURCE_DATA_REQUEST = 'GET_RESOURCE_DATA_REQUEST';
export const GET_RESOURCE_DATA_FAILED = 'GET_RESOURCE_DATA_FAILED';

export const GET_RESOURCE_COUNTERS = 'GET_RESOURCE_COUNTERS';
export const GET_RESOURCE_COUNTERS_FAILED = 'GET_RESOURCE_COUNTERS_FAILED';

export const GET_EVENT_COUNTERS_HISTORY = 'GET_EVENT_COUNTERS_HISTORY';
export const GET_EVENT_COUNTERS_HISTORY_FAILED = 'GET_EVENT_COUNTERS_HISTORY_FAILED';

export function getCalendarResourcesByOrgs(organizationsIds) {
  return async (dispatch, getState, { api }) => {
    dispatch({ type: GET_CALENDAR_RESOURCES_BY_ORGS_REQUEST });

    const response = await api(
      {
        _model: 'resources',
        _action: 'getByOrganizationsForCalendar',
        organizationsIds
      },
      getState
    );

    if (response.success) {
      return dispatch({ type: GET_CALENDAR_RESOURCES_BY_ORGS, payload: response });
    }
    return dispatch({ type: GET_CALENDAR_RESOURCES_BY_ORGS_FAILED });
  };
}

export function getCounterData(organizationID, id, type) {
  return async (dispatch, getState, { api }) => {
    dispatch({ type: GET_COUNTER_DATA_REQUEST });

    const response = await api(
      {
        _model: 'calendar',
        _action: 'getResourceData',
        organizationID,
        id,
        type
      },
      getState
    );

    if (response.success) {
      dispatch({ type: GET_COUNTER_DATA, payload: response.data, meta: { id } });
    } else {
      dispatch({ type: GET_COUNTER_DATA_FAILED, payload: response.data });
    }
    return response;
  };
}

export function getResource(organizationID, resourceID) {
  return async (dispatch, getState, { api }) => {
    try {
      dispatch(setProgress(true, `${GET_RESOURCE_DATA}-${resourceID}`));
      const response = await api(
        {
          _model: 'resources',
          _action: 'getResource',
          organizationID,
          resourceID
        },
        getState
      );
      if (response.success) {
        dispatch({ type: GET_RESOURCE_DATA, payload: response.data });
        return dispatch(setProgress(false, `${GET_RESOURCE_DATA}-${resourceID}`));
      }

      dispatch(setProgress(false, `${GET_RESOURCE_DATA}-${resourceID}`));
      return dispatch({ type: GET_RESOURCE_DATA_FAILED, payload: response });
    } catch (e) {
      dispatch(setProgress(false, `${GET_RESOURCE_DATA}-${resourceID}`));
      return dispatch(setMessages({ type: 'error', text: e.message }));
    }
  };
}

export function getResourceCounters(organizationID, id, type) {
  return async (dispatch, getState, { api }) => {
    try {
      dispatch(setProgress(true, `${GET_RESOURCE_COUNTERS}-${id}`));
      const response = await api(
        {
          _model: 'resources',
          _action: 'getResourceCounters',
          organizationID,
          id,
          type
        },
        getState
      );

      if (response.success) {
        dispatch({ type: GET_RESOURCE_COUNTERS, payload: response.data, meta: { id } });
        return dispatch(setProgress(false, `${GET_RESOURCE_COUNTERS}-${id}`));
      }
      dispatch(setProgress(false, `${GET_RESOURCE_COUNTERS}-${id}`));
      return dispatch({ type: GET_RESOURCE_COUNTERS_FAILED, payload: response.data });
    } catch (e) {
      dispatch(setProgress(false, `${GET_RESOURCE_COUNTERS}-${id}`));
      return dispatch(setMessages({ type: 'error', text: e.message }));
    }
  };
}

export function getEventCountersHistory(organizationID, eventID) {
  return async (dispatch, getState, { api }) => {
    try {
      dispatch(setProgress(true, `${GET_EVENT_COUNTERS_HISTORY}-${eventID}`));
      const response = await api(
        {
          _model: 'calendar',
          _action: 'getEventCountersHistory',
          organizationID,
          eventID
        },
        getState
      );

      if (response.success) {
        dispatch({ type: GET_EVENT_COUNTERS_HISTORY, payload: response.data, meta: { eventID } });
        return dispatch(setProgress(false, `${GET_EVENT_COUNTERS_HISTORY}-${eventID}`));
      }
      dispatch(setProgress(false, `${GET_EVENT_COUNTERS_HISTORY}-${eventID}`));
      return dispatch({ type: GET_EVENT_COUNTERS_HISTORY_FAILED, payload: response });
    } catch (e) {
      dispatch(setProgress(false, `${GET_EVENT_COUNTERS_HISTORY}-${eventID}`));
      return dispatch(setMessages({ type: 'error', text: e.message }));
    }
  };
}
